<template>
  <div class="imgModuleWrapper">
    <!--实拍图-->
    <div v-if="showRealPhoto" class="img-module">
      <div class="tag">实拍图（{{ dataInfo.pics.length }}）</div>
      <div class="img-list">
        <div
          v-for="(imgUrl, index) in dataInfo.pics"
          :key="index"
          v-lazy:background-image="{ src: $setPicSize(imgUrl) }"
          class="img"
          zz-sortId="1"
          zz-sortName="实拍图"
          @click="previewImageChoice(index, detailBottomImgList, detailTopImgList)"
        />
      </div>
    </div>
    <!-- 成色检测 -->
    <div
      v-if="tabsList && tabsList.length && dataInfo.showRedHubPicture"
      class="quality"
      :class="{ 'flow-bottom': dataInfo.showRedHubPicture }"
    >
      <div class="quality__title">
        <div class="title_left">成色检测</div>
        <div class="title_right">{{ `共${defailLen}个细节项` }}</div>
      </div>
      <div class="tabs">
        <div
          v-for="(item, index) in tabsList"
          :key="item + index"
          class="tab_item"
          :class="{
            active: activeIndex === index,
            'dark-tab': item.position !== '正面' && activeIndex === index,
          }"
          @click="tabClick(index)"
        >
          {{
            `${item.position}${defailImgLength(item) ? '(' + defailImgLength(item) + ')' : ''}
          `
          }}
        </div>
      </div>

      <div class="footer" :class="{ dynamicBackground: qualityItem.position !== '正面' }">
        <!-- 图片 & canvas画布 -->
        <canvas id="flawCanvas" class="flaw_canvas"></canvas>
        <div class="background_img">
          <img :src="$setPicSize(qualityItem.zzPicUrl)" alt="" />
        </div>
        <div class="left_img">
          <div
            v-for="(leImg, leIndex) in qualityItem.leftDefectsData.slice(0, 4)"
            :key="leImg.badPhotoUrl"
            class="left_img_item"
            :class="`left_img_item${leIndex}`"
            @click="
              {
                let tmo = leIndex
                const curL = qualityItem.leftDefectsData.filter((item) => item.zzPicUrl).length
                const curR = qualityItem.rightDefectsData.filter((item) => item.zzPicUrl).length
                if (curL === 2 && curR === 2 && leIndex == 3) {
                  tmo = 1
                }
                handleImgPreview(
                  dataInfo.pics.length + prevLen + tmo,
                  detailBottomImgList,
                  detailTopImgList
                )
              }
            "
          >
            <template v-if="leImg.zzPicUrl">
              <div class="img_inner">
                <img :src="$setPicSize(leImg.zzPicUrl)" alt="" />
                <div
                  v-if="leImg.labelDesc"
                  class="quality_text"
                  :class="{ 'dynamic-background-color': qualityItem.position !== '正面' }"
                >
                  {{ leImg.labelDesc }}
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="right_img">
          <div
            v-for="(riImg, riIndex) in qualityItem.rightDefectsData.slice(0, 4)"
            :key="riImg.badPhotoUrl"
            class="right_img_item"
            :class="`right_img_item${riIndex}`"
            @click="
              {
                let tmo = riIndex
                const curL = qualityItem.leftDefectsData.filter((item) => item.zzPicUrl).length
                const curR = qualityItem.rightDefectsData.filter((item) => item.zzPicUrl).length
                if (curL === 1 && curR === 1) {
                  tmo = 0
                } else if (curL === 2 && curR === 2 && riIndex == 3) {
                  tmo = 1
                }

                handleImgPreview(
                  dataInfo.pics.length + prevLen + curL + tmo,
                  detailBottomImgList,
                  detailTopImgList
                )
              }
            "
          >
            <template v-if="riImg.zzPicUrl">
              <div class="img_inner">
                <img :src="$setPicSize(riImg.zzPicUrl)" alt="" />
                <div
                  v-if="riImg.labelDesc"
                  class="quality_text"
                  :class="{ 'dynamic-background-color': qualityItem.position !== '正面' }"
                >
                  {{ riImg.labelDesc }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!--细节图-->
    <div v-if="config.badPics && config.badPics.length > 0" class="img-module">
      <div class="tag">
        细节{{
          config.badPics && config.badPics.length > 0 && !dataInfo.showRedHubPicture
            ? '图（' + config.badPics.length + '）'
            : ''
        }}
      </div>
      <div v-if="defailTextArr && defailTextArr.length" class="details-info">
        <div class="info-box">
          <div
            v-for="item in defailTextArr"
            :key="item"
            class="info"
            :class="{ info__item: !dataInfo.showRedHubPicture }"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div
        v-if="config.badPics && config.badPics.length > 0 && !dataInfo.showRedHubPicture"
        class="img-list"
      >
        <div
          v-for="(imgUrl, index) in config.badPics"
          :key="index"
          v-lazy:background-image="{ src: $setPicSize(imgUrl) }"
          class="img"
          zz-sortId="2"
          zz-sortName="细节图"
          @click="handleImgPreviewBefore(index, config.badPics)"
        />
      </div>
    </div>
  </div>
</template>
<script lang="js">
  import Vue from 'vue'
  import native from '@zz-common/native-adapter'
  // import { isZZ } from '@/libs/environment'
  import { setPicSize } from '@zz-common/zz-utils'

  import { ImagePreview, Toast } from '@zz-common/zz-ui'
  Vue.use(ImagePreview).use(Toast)
  const UA = window.navigator.userAgent
  export const isIOS = !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  export const isAndroid = UA.includes('Android') || UA.includes('Adr')
  export const isZZ = UA.toLowerCase().includes('zhuanzhuan')
  export default ({
    components: {},
    props: {
      dataInfo: {
        type: Object
      },
      config: {
        type: Object,
        default: () => ({})
      },
      warehouseInfo: {
        type: String,
        default: ''
      },
      infoId: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        activeIndex: 0,
        // 最终形式如 [[65,80],[0,53, 0,62]] 第一个数组为起点坐标，第二个数组为终点坐标
        coordinatePairs: [
        [[40, 0]],
          [[40, 154]],
          [[40, 308]],
          [[40, 462]],
          [[470, 0]],
          [[470, 154]],
          [[470, 308]],
          [[470, 462]]
        ]
      }
    },

    computed: {
      $setPicSize() {
        return setPicSize
      },

      iszzt() {
        return native.in('zztong')
      },

      // 细节文案 包含老文案和新文案
      defailTextArr(){
        if(this.dataInfo.showRedHubPicture){
          return this.config.productDefectInfoDTO.conditionDescList || []
        }
        return this.config.productCondition || []
      },

      // 需要传入客户端的细节图数据
      detailTopImgList() {
        // 处理细节图数据
        const imgList = []
        this.tabsList.forEach(item => {
          const { leftDefectsData, rightDefectsData, position, zzPicUrl } = item
          // 由于存在多个细节图对应同一个实拍图的case 所以实拍图的数据也在这里处理
          getData(imgList, leftDefectsData, position, zzPicUrl)
          getData(imgList, rightDefectsData, position, zzPicUrl)
        })

        return imgList

        function getData(imgList, arr, position, pic) {
          arr.filter(item => item.zzPicUrl).forEach(img => {
            const textDesc = (img.conditionDesc && position) ? (position + '-' + img.conditionDesc) : ''
            imgList.push({
              img: pic,
              poiX: img.poiX,
              poiY: img.poiY,
              textDesc,
              pic: img.zzPicUrl
            })
          })
        }
      },

      // 需要传入客户端的细节图数据
      detailBottomImgList() {
        return this.tabsList.map(item => item.zzPicUrl)
      },

      /**
       * $ 是否展示实拍图模块
       */
      showRealPhoto() {
        const { infoType, pics } = this.dataInfo
        return infoType === 1 && pics?.length > 0
      },
      tabsList() {
        return this.config?.productDefectInfoDTO?.defectInfos || []
      },
      qualityItem() {
        // 处理特殊情况 只有两个细节图 并且一左一右 需要将右侧的细节图放在底部展示 插入3个空对象 占位作用
        const obj = this.tabsList[this.activeIndex]
        if (obj?.leftDefectsData?.length === 1 && obj?.rightDefectsData?.length === 1) {
          for (let i = 0; i < 3; i++) {
            obj.rightDefectsData.unshift({})
          }
        }
        // 有四个细节图 分别是两左两右 需要左侧、右侧分别插入两个空对象 占位作用
        if (obj?.leftDefectsData?.length === 2 && obj?.rightDefectsData?.length === 2){
          for(let i = 0; i < 2; i++){
            obj.leftDefectsData.splice(1, 0, {})
            obj.rightDefectsData.splice(1, 0, {})
          }
        }
        return obj
      },
      // 计算当前tab之前共有多少图片
      prevLen(){
        let total = 0
        for(let i = 0; i< this.activeIndex; i++){
          const item = this.tabsList[i]
          total += item.leftDefectsData?.filter(it => it.zzPicUrl).length
          total += item.rightDefectsData?.filter(it => it.zzPicUrl).length
        }
        return total
      },
      // 总体的细节图数量
      defailLen() {
        let total = 0
        this.tabsList.forEach(item => {
          total += item.leftDefectsData?.filter(it => it.zzPicUrl).length
          total += item.rightDefectsData?.filter(it => it.zzPicUrl).length
        })
        return total
      },

    },

    methods: {
      // 计算每个面的细节图数量
      defailImgLength(item) {
        const { leftDefectsData, rightDefectsData } = item
        const leftLength = leftDefectsData?.filter(
          (item) => item.zzPicUrl
        ).length
        const rightLength = rightDefectsData?.filter(
          (item) => item.zzPicUrl
        ).length
        return leftLength + rightLength
      },
       createFeedbackUrl() {
      const questionnaireId = '1702591683343946240'
      const infoId = this.infoId
      const { cateFirstId, title, infoLv, handPriceVo } = this.config
      const extend = {
        // 页面名称
        pageName: '奢侈品商品大图',
        // 品类
        pgCateId: cateFirstId,
        // 商品 id
        infoId,
        // 商品标题
        infoName: title || '',
        quality: infoLv?.level || '',
        price: (handPriceVo?.handPriceCent || 0) / 100
      }
      const jumpUrl = `https://m.zhuanzhuan.com/common/uem/index.html?questionnaireId=${questionnaireId}&extend=${encodeURIComponent(
        encodeURIComponent(JSON.stringify(extend))
      )}&needHideHead=3&wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.8#/question-bch`

      return jumpUrl
    },
    previewImageChoice(index, picList,detailList){
      if(!this.dataInfo.showRedHubPicture){
        console.log(index, this.dataInfo.pics);
          this.handleImgPreviewBefore(index, this.dataInfo.pics.map((item) => setPicSize(item, 1000, 1000)))
      }else {
        this.handleImgPreview(index, picList,detailList)
      }
    },
    // 图片预览 旧
    handleImgPreviewBefore(index, picList){

      if (isZZ) {
        native.wrap('hasSupportFeature')(
          {
            method: 'browserLuxuryImages'
          },
          (res) => {
            if (parseInt(res.code) >= 0) {
              const tabList = [
                {
                  name: '图片',
                  imgList: picList
                }
              ]
              native.wrap('browserLuxuryImages')(
                {
                  selectedIndex: index,
                  tabList
                },
                () => {}
              )
            } else {
              ImagePreview({
                images: picList.map((item) => setPicSize(item, 1000, 1000)),
                startPosition: index,
                showClose: true,
                adaptApp: true, // 端内
                adaptWeixin: true // 微信端内
              })
            }
          }
        )
      } else if(this.iszzt){
        ImagePreview({
          images: picList.map((item) => setPicSize(item, 1000, 1000)),
          startPosition: index,
          showClose: true,
          adaptApp: true, // 端内
          adaptWeixin: true, // 微信端内
          showDownload: true,
          onDownload: ()=> {
            native.wrap('saveImageToAlbum')(
              {
                imageUrl: picList[index],
              },
              (res) => {
                const { code, msg } = res
                if (code === '0') {
                  Toast.success('图片保存成功')
                } else {
                  Toast.fail(msg)
                }
              }
            )
          }
        })
      }else {
        ImagePreview({
          images: picList.map((item) => setPicSize(item, 1000, 1000)),
          startPosition: index,
          showClose: true,
          adaptApp: true, // 端内
          adaptWeixin: true // 微信端内
        })
      }
    },
      /**
   * $ 图片预览
   */
      handleImgPreview(index, picList, detailList) {
        console.log(index, 'index');
        const jumpUrl = this.createFeedbackUrl()
        const imgDataList = []
        const tabList = []
        detailList.forEach(item => {
          imgDataList.push({
            url: setPicSize(item.pic, 1000, 1000),
            flawTitle: item.textDesc
          })
        })
        const goodsMsg = {
              goodsAddress: this.warehouseInfo || '',
              goodsNumber: this.config?.qcCode
                ? `证书编号：${this.config?.qcCode}`
                : ''
            }
            if(this.dataInfo?.pics){
              tabList.push({
                tabName: '概况',
                name: '实拍',
                imgList: this.dataInfo.pics.map(item => setPicSize(item, 1000, 1000)),
                actionButton: {
                  text: '反馈',
                  jumpUrl
                }
            })
            }
            tabList.push({
                tabName: '细节',
                name: '细节',
                imgDataList,
                topImgList: detailList,
                actionButton: {
                  text: '反馈',
                  jumpUrl
                }
            })

            console.log({
                    selectedIndex: index,
                    tabList,
                    ...goodsMsg
                  }, 'tabList');
        if (isZZ) {
          native.wrap('hasSupportFeature')(
            {
              method: 'browserLuxuryImages'
            },
            (res) => {
              if (parseInt(res.code) >= 0) {
                native.wrap('browserLuxuryImages')(
                  {
                    selectedIndex: index,
                    tabList,
                    ...goodsMsg
                  },
                  () => { }
                )
              } else {
                ImagePreview({
                  images: picList.map((item) => setPicSize(item, 1000, 1000)),
                  startPosition: index,
                  showClose: true,
                  adaptApp: true, // 端内
                  adaptWeixin: true // 微信端内
                })
              }
            }
          )
        } else {
          ImagePreview({
            images: picList.map((item) => setPicSize(item, 1000, 1000)),
            startPosition: index,
            showClose: true,
            adaptApp: true, // 端内
            adaptWeixin: true // 微信端内
          })
        }
      },
      // canvas 绘图
      drawTwoRightAngles(coordinatePairs) {
        const canvas = document.getElementById('flawCanvas')
        if(!canvas) return
        const context = canvas.getContext('2d')
        const clientWidth = document.documentElement.clientWidth
        // 获取设备的像素比例
        const dpr = window.devicePixelRatio;
        //根据设计图中的canvas画布的占比进行设置
        // canvas 在移动端模糊原因： 在移动端盛行，高清屏基本上已经普及的现在，
        // 1px的css像素实际上代表了4个甚至更多的物理像素。但是由于我们的代码问题，
        // 我们1px的css像素和1个canvas像素画上了等号，
        // 也就导致了1个canvas像素实际需要填充4个甚至更多物理像素，
        // 为了保证图像平滑处理，在填充剩余的物理像素时采用了原先颜色的近似值，导致了图像的模糊

        /* 解决： 根据devicePixelRatio 属性，扩大canvas画布的像素，使1个canvas像素和1个物理像素相等 */
        canvas.style.width = 470 + "px";
        canvas.style.height = 495 + "px";
        canvas.width = 470 * dpr;
        canvas.height = 495 * dpr;
        // const canvasImgWidth = Math.floor((clientWidth * 470) / 750)
        // const canvasImgHeight = Math.floor((clientWidth * 495) / 750)

        // canvas.setAttribute('width', canvasImgWidth + 'px')
        // canvas.setAttribute('height', canvasImgHeight + 'px')

        context.clearRect(0, 0, canvas.width, canvas.height)
        context.scale(dpr, dpr)

        for (let i = 0; i < coordinatePairs.length; i++) {
          const pair = coordinatePairs[i] //   [[50, 50], point1],
          // 过滤不符合条件的case
          if (pair.length < 2) continue
          /* canvas绘制线条是从中间向两边绘制的，比如说定义x坐标为1，
          它会以1为中心，向左0.5像素，向右0.5像素
          ，但是渲染时不支持小于0.5像素，所以会绘制成1像素，
          然后左边右边各1像素，你得到得就是双倍加粗版线条

          解决： 把 x 的值加或者减0.5像素，这样它就可以完整渲染1像素了*/
          const x1 = (clientWidth / 750) * pair[0][0] + 0.5
          const y1 = (clientWidth / 750) * pair[0][1] + 0.5
          const x2 = (clientWidth / 750) * pair[1][0] * 470+ 0.5
          const y2 = (clientWidth / 750) * pair[1][1] * 495+ 0.5

          // const x2 = 100
          // const y2 = 200

          context.strokeStyle = 'rgba(179, 179, 179, 0.6)'
          context.lineWidth = 0.3 * dpr

          // 绘制第一条边
          context.beginPath()
          context.moveTo(x1, y1)
          context.lineTo(x2, y1)
          context.stroke()

          // 绘制第二条边
          context.beginPath()
          context.moveTo(x2, y1)
          context.lineTo(x2, y2)
          context.stroke()

          // 绘制同心圆
          const radius = 2 * dpr
          const strokeWidth = 0.5
          context.fillStyle = 'rgba(66, 66, 66, 0.6)'
          context.beginPath()
          context.arc(x2, y2, radius, 0, 2 * Math.PI)
          context.fill()

          // 绘制描边
          context.lineWidth = strokeWidth
          context.strokeStyle = 'rgba(255, 255, 255, 0.6)'
          context.stroke()

          // 绘制内层圆
          context.fillStyle = '#fff'
          const innerRadius = radius * (4 / 10)
          context.beginPath()
          context.arc(x2, y2, innerRadius, 0, 2 * Math.PI)
          context.fill()

        }
      },
      tabClick(index) {
        this.activeIndex = index
        this.processCoordinate()
      },
      // 处理坐标数据
      processCoordinate() {
        this.coordinatePairs = [
          [[40, 0]],
          [[40, 154]],
          [[40, 308]],
          [[40, 462]],
          [[470, 0]],
          [[470, 154]],
          [[470, 308]],
          [[470, 462]]
        ]
        if (this.qualityItem?.leftDefectsData && this.qualityItem.leftDefectsData?.length) {
          for (let i = 0; i < 4; i++) {
            // 商品有返回细节图才算有效数据
            const cur = this.qualityItem?.leftDefectsData[i]
            if (cur && Object.keys(cur).length && cur.zzPicUrl) this.coordinatePairs[i].push([cur.poiX, cur.poiY])
          }
        }
        if (this.qualityItem?.rightDefectsData && this.qualityItem.rightDefectsData?.length) {
          for (let i = 4; i < 8; i++) {
            const cur = this.qualityItem?.rightDefectsData[i - 4]
            if (cur && Object.keys(cur).length && cur.zzPicUrl) this.coordinatePairs[i].push([cur.poiX, cur.poiY])
          }
        }
        // 切换tab重新绘制
        this.drawTwoRightAngles(this.coordinatePairs)
      }
    },

    mounted() {
      this.processCoordinate()
      // canvas 绘制
      if(this.tabsList && this.tabsList.length && this.dataInfo.showRedHubPicture) {
        this.drawTwoRightAngles(this.coordinatePairs)
      }

    }

  })
</script>
<style lang="scss" scoped>
  .imgModuleWrapper {
    padding: 48px 0 0;
  }
  .flow-bottom {
    margin-bottom: 48px;
  }

  .img-module {
    box-sizing: border-box;
    width: 590px;
    margin: 0 auto;
    margin-bottom: 24px;
    padding: 0 0 24px;
    border-radius: 4px;

    .tag {
      color: #111111;
      font-weight: 500;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      line-height: 24px;
    }

    .details-info {
      display: flex;
      flex-direction: column;
      margin-top: 6px;

      .info-box {
        margin-top: 18px;

        .info {
          padding: 12px 0;
          color: #999999;
          font-weight: 400;
          font-size: 22px;
          font-family: PingFangSC-Light;
          line-height: 20px;

          &:last-child {
            margin-bottom: 0;
          }
        }
        .info__item {
          line-height: 40px;
        }
      }
    }

    .img-list {
      margin-top: 24px;
      overflow: auto;
      overflow-y: hidden;
      white-space: nowrap;

      &::-webkit-scrollbar {
        display: none;
      }

      .img {
        display: inline-block;
        width: 128px;
        height: 128px;
        margin-right: 6px;
        background-size: cover;
        border-radius: 4px;
      }
    }
  }

  .quality {
    // margin-top: 48px;
    padding: 0 32px;
    height: 810px;

    &__title {
      display: flex;
      justify-content: space-between;
    }

    .title_left {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #111111;
      line-height: 28px;
      text-align: left;
      font-style: normal;
    }

    .title_right {
      padding-top: 4px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 300;
      font-size: 20px;
      color: #999999;
      line-height: 20px;
      text-align: right;
      font-style: normal;
    }

    .tabs {
      width: 597px;
      margin-top: 28px;
      background: #fbfbfb;
      border-radius: 8px 8px 0 0;
      overflow: auto;
      overflow-y: hidden;
      white-space: nowrap;
      &::-webkit-scrollbar {
        display: none;
      }

      .tab_item {
        width: 120px;
        height: 76px;
        display: inline-block;
        text-align: center;

        font-family: PingFangSC, PingFang SC;
        font-weight: 300;
        font-size: 24px;
        color: #666666;
        line-height: 76px;
      }

      .active {
        font-weight: 500;
        font-size: 24px;
        color: #111111;
        background: #fff;
        border-radius: 8px 8px 0px 0px;

        &::after {
          content: '';
          display: block;
          width: 30px;
          height: 6px;
          background: #ff483c;
          border-radius: 100px;
          position: relative;
          // left: 45px;
          // top: -18px;
          top: -25%;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }
      .dark-tab {
        background: #f0f0f0;
      }
    }
    .dynamicBackground {
      background: rgba(240, 240, 240, 1);
      border: none;
    }

    .footer {
      width: 598px;
      height: 678px;
      position: relative;
      border: 0.5px solid #f0f0f0;
      border-top: none;

      // background: #fff;
      border-radius: 0 0 8px 8px;

      .background_img {
        width: 598px;
        padding: 104px 64px;

        img {
          width: 470px;
          height: 470px;
        }
      }

      .flaw_canvas {
        position: absolute;
        z-index: 2;
        top: 79px;
        left: 64px;
      }

      .left_img {
        position: absolute;
        left: 0;
        top: 0;
        width: 20%;
        height: 20%;
        z-index: 5;

        .left_img_item {
          width: 80px;
          height: 80px;

          img {
            width: 80px;
            height: 80px;
            border-radius: 4px;
          }
        }

        .left_img_item0 {
          position: relative;
          left: 25px;
          top: 40px;
        }

        .left_img_item1 {
          position: relative;
          left: 25px;
          top: 114px;
        }

        .left_img_item2 {
          position: relative;
          left: 25px;
          top: 188px;
        }

        .left_img_item3 {
          position: relative;
          left: 25px;
          top: 262px;
        }
      }

      .right_img {
        position: absolute;
        left: 0;
        top: 0;
        width: 20%;
        height: 20%;
        z-index: 4;

        .right_img_item {
          width: 80px;
          height: 80px;

          img {
            width: 80px;
            height: 80px;
            border-radius: 4px;
          }
        }

        .right_img_item0 {
          position: relative;
          left: 493px;
          top: 40px;
        }

        .right_img_item1 {
          position: relative;
          left: 493px;
          top: 114px;
        }

        .right_img_item2 {
          position: relative;
          left: 493px;
          top: 188px;
        }

        .right_img_item3 {
          position: relative;
          left: 493px;
          top: 262px;
        }
      }

      .img_inner {
        .quality_text {
          width: 106px;
          padding-top: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 300;
          font-size: 17px;
          color: #666666;
          // line-height: 26px;
          font-style: normal;
          background: #fff;
          border-radius: 4px;
          position: relative;
          left: -17px;
          padding: 4px;

          display: flex;
          justify-content: center;
          align-items: center;
        }
        .dynamic-background-color {
          background: #f0f0f0;
        }
      }
    }
  }
</style>
